import { render, staticRenderFns } from "./CustomerIssueCoupon.vue?vue&type=template&id=2be9f1f8&scoped=true&"
import script from "./CustomerIssueCoupon.vue?vue&type=script&lang=js&"
export * from "./CustomerIssueCoupon.vue?vue&type=script&lang=js&"
import style0 from "./CustomerIssueCoupon.vue?vue&type=style&index=0&id=2be9f1f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be9f1f8",
  null
  
)

export default component.exports